import { Link } from "react-router-dom";
import { Download, Wrench, SlidersHorizontal } from "lucide-react";
import { Button } from "@/components/ui/button";

export function PortalHome() {
  return (
    <div className="space-y-5">
      <div>
        <h1 className="text-xl font-semibold">Portal Home</h1>
        <p className="text-sm text-muted-foreground mt-1">
          Manage downloads, templates, and report preferences from one workspace.
        </p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-3">
        <Link to="/portal/downloads" className="rounded-lg border border-border/50 p-4 hover:bg-accent/30 transition-colors">
          <div className="flex items-center gap-2 text-sm font-medium"><Download className="h-4 w-4" /> Downloads</div>
          <p className="text-xs text-muted-foreground mt-2">Get the latest LiveSpeak desktop build.</p>
        </Link>
        <Link to="/portal/templates" className="rounded-lg border border-border/50 p-4 hover:bg-accent/30 transition-colors">
          <div className="flex items-center gap-2 text-sm font-medium"><Wrench className="h-4 w-4" /> Template Builder</div>
          <p className="text-xs text-muted-foreground mt-2">Customize section order, assertion style, and canonical phrasing.</p>
        </Link>
        <Link to="/portal/report-preferences" className="rounded-lg border border-border/50 p-4 hover:bg-accent/30 transition-colors">
          <div className="flex items-center gap-2 text-sm font-medium"><SlidersHorizontal className="h-4 w-4" /> Report Preferences</div>
          <p className="text-xs text-muted-foreground mt-2">Choose Conservative, Balanced, or Detailed output mode.</p>
        </Link>
      </div>

      <div className="rounded-lg border border-border/50 p-4 bg-background/60">
        <div className="text-sm font-medium">Quick Start</div>
        <p className="text-sm text-muted-foreground mt-1">
          If you are setting up a new workflow, start with Downloads, then configure your default templates and report mode.
        </p>
        <div className="mt-3">
          <Button asChild size="sm">
            <Link to="/portal/downloads">Open Downloads</Link>
          </Button>
        </div>
      </div>
    </div>
  );
}
